import { IReports, IReportsLI, IReportsResponseType } from "./Reports_IT";

export default class Reports implements IReports {
    total: number;
    data: IReportsLI[] = [];
    constructor(data: IReportsResponseType) {
        this.total = data.response.length;
        for(let i of data.response) {
            this.data.push(i)
        }
    }
}